(() => {
  document.querySelectorAll('[data-shop-hub]').forEach((hub) => {
    if (hub.dataset.shopHubBound === 'true') return;
    hub.dataset.shopHubBound = 'true';

    const tabs = [...hub.querySelectorAll('[data-shop-hub-tab]')];
    const panels = [...hub.querySelectorAll('[data-shop-hub-panel]')];
    if (!tabs.length || !panels.length) return;

    const activate = (key, focus = false) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.shopHubTab === key;
        tab.classList.toggle('active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach((panel) => {
        const active = panel.dataset.shopHubPanel === key;
        panel.hidden = !active;
        panel.classList.toggle('active', active);
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab.dataset.shopHubTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const next = (index + direction + tabs.length) % tabs.length;
        activate(tabs[next].dataset.shopHubTab, true);
      });
    });

    const initial = tabs.find((tab) => tab.classList.contains('active')) || tabs[0];
    activate(initial.dataset.shopHubTab);
  });
})();
